export default "__VITE_ASSET__DkdWjdck__"